export default "__VITE_ASSET__pRywvonO__"